<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'SchemeIndex',
  data() {
    return {}
  },
  methods: {},
  mounted() {},
  beforeDestroy() {},
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/plant/programme/Index.vue